import React from "react";

type Props = {
  handleResizeMouseDown: (e: React.MouseEvent) => void;
};

export const ResizeHandleOnMouseDown = ({ handleResizeMouseDown }: Props) => {
  return (
    <div
      onMouseDown={handleResizeMouseDown}
      className="absolute top-0 -right-0.5 z-20 h-full w-1 cursor-col-resize transition-colors hover:bg-blue-400 active:bg-blue-500"
      title="Drag to resize"
    />
  );
};
